export default __webpack_public_path__ + "static/slovenia-886b2ee70019966d16ebdc3bf1b8c0ae.svg";